import complaintsservice from '../services/complaintandfeedbackservice';
import * as appActions from '../../../actions/appactions';
import * as types from "./actiontype";
import { checkAccess } from '../../../actions/securityactions'
import * as appConstants from '../../../overrides/appconstants';
import * as appUtilityFunctions from '../../../infrastructure/apputilityfunctions'


export const updateNewComplaintParams = ({ name, value }) => {
  return {
    type: types.UPDATE_NEW_COMPLAINTS_PARAMS,
    payload: { name, value }
  }
}

export const resetNewComplaintParamsWithoutComplaint = () => {
  return {
    type: types.RESET_NEW_COMPLAINT_INFORMATION_WITHOUT_COMPLAINT_NUMBER
  }
}
export const updateTabModalsStateParams = ({ name, value }) => {
  return {
    type: types.UPDATE_MODAL_DISPLAY_STATE,
    payload: { name, value }
  }
}

export function getInsuredInfoMasters() {
  return async function (dispatch, state) {
    try {
      dispatch(appActions.setLoading(true));

      let sr = await complaintsservice.getInsuredInformationMasters();
      if (sr.result) {
        dispatch(getInsuredInformationMastersEnd(sr.result));
      }
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }

      return true
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const getInsuredInformationMastersEnd = (result) => {
  return {
    type: types.GET_INS_SHARED_MASTERS_END,
    result
  }
}
export function getSharedComplaintsMasters() {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      let result = await complaintsservice.getSharedComplaintsMasters();
      console.log('getSharedComplaintsMasters', result)
      dispatch(getSharedComplaintsMastersEnd(result));
      console.log('getSharedComplaintsMasters', currentState.masters)
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const getSharedComplaintsMastersEnd = (result) => {
  return {
    type: types.GET_SHARED_COMPLAINTS_FEEDBACK_MASTERS_END,
    payload: result
  }
}
export function getComplaintDetails(complaintId) {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      let para = {
        'complaintId': complaintId
      }
      dispatch(appActions.setLoading(true));
      let result = await complaintsservice.getComplaintDetails(para);
      console.log('SUMMARYLIST', result)

      //console.log(sr)
      // if (result==null)
      //   {return false;}

      // if(result.complaintDetails.complaintId)
      if (result != null) {
        dispatch(getComplaintDetailsEnd(result));
        //dispatch(updateComplaintTypeState(true,result));
      }
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const getComplaintDetailsEnd = (result) => {
  return {
    type: types.GET_COMPLAINT_DETAILS_END,
    payload: result
  }
}

export const updateFileChange = ({ id, field, name, docIdEncrypted, type, date }) => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    let index = id;
    let fieldName = field;
    let fieldValue = docIdEncrypted;
    let fileName = name;
    let fileType = type;
    let uploadedDate = date;
    try {
      dispatch(appActions.setLoading(true));
      let updatedFile = {
        ...currentState.documents.documentList[index],
        [fieldName]: fieldValue,
        fileName: fileName,
        fileType: fileType,
        uploadedDate: uploadedDate
      }
      console.log(updatedFile)
      const spliceDocInfo = [...currentState.documents.documentList]
      spliceDocInfo.splice(index, 1)
      console.log(spliceDocInfo)
      spliceDocInfo.splice(index, 0, updatedFile);
      console.log(spliceDocInfo)
      dispatch(updateFileChangeEnd(spliceDocInfo))
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const updateFileChangeEnd = (updatedFile) => {
  return {
    type: types.UPDATE_FILE_CHANGE_END,
    payload: { updatedFile }
  }
}
export const updateDocumentParamsEnd = (updatedDocParams) => {
  return {
    type: types.UPDATE_DOCUMENT_PARAMS_END,
    payload: { updatedDocParams }
  }
}
export const updateDocumentParams = ({ id, name, value }) => {
  return function (dispatch, state) {
    let currentState = getState(state());
    let index = id;
    let fieldName = name;
    let fieldValue = value;
    try {
      dispatch(appActions.setLoading(true));
      let updatedParam = {
        ...currentState.documents.documentList[index],
        [fieldName]: fieldValue
      }
      console.log(updatedParam)
      const spliceDocInfo = [...currentState.documents.documentList]
      spliceDocInfo.splice(id, 1)
      console.log(spliceDocInfo)
      spliceDocInfo.splice(id, 0, updatedParam);
      console.log(spliceDocInfo)
      dispatch(updateDocumentParamsEnd(spliceDocInfo))

    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const saveDocuments = () => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      let documents = currentState.documents.documentList;
      let saveDoc = {
        "ComplaintId": currentState.complaintDetails.complaintId,
        "Documents": documents
      }
      let sr = await complaintsservice.saveDocuments(saveDoc);
      console.log(sr);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      else {
        //dispatch(appActions.showMessage("Documents Successfully Saved!", { buttons: ['Ok'] }));
      }
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export function saveComplaintInfo() {
  return async function (dispatch, state) {
    let currentState = getState(state());
    console.log('587866', currentState.documents.documentList);
    let documents = currentState.documents.documentList;
    try {
      dispatch(appActions.setLoading(true));
      let saveComplaintInfo = {
        "SourceName": currentState.newComplaint.sourceName == "" || currentState.newComplaint.sourceName == null ? 0 : currentState.newComplaint.sourceName,
        "FullName": currentState.newComplaint.fullName == "" || currentState.newComplaint.fullName == null ? null : currentState.newComplaint.fullName,
        "Email": currentState.newComplaint.email == "" || currentState.newComplaint.email == null ? null : currentState.newComplaint.email,
        "MobileNumber": currentState.newComplaint.mobileNumber == "" || currentState.newComplaint.mobileNumber == null ? null : currentState.newComplaint.mobileNumber,
        //"PostalAddress": currentState.newComplaint.postalAddress == "" || currentState.newComplaint.postalAddress == null ? null : currentState.newComplaint.postalAddress,
        "PlateNumber": currentState.newComplaint.plateNumber == "" || currentState.newComplaint.plateNumber == null ? null : currentState.newComplaint.plateNumber,
        "PolicyNumber": currentState.newComplaint.policyNumber == "" || currentState.newComplaint.policyNumber == null ? null : currentState.newComplaint.policyNumber,
        "StatusName": currentState.newComplaint.statusName == "" || currentState.newComplaint.statusName == null ? null : currentState.newComplaint.statusName,
        "LineOfBuisness": currentState.newComplaint.lineOfBuisness == "" || currentState.newComplaint.lineOfBuisness == null ? 0 : currentState.newComplaint.lineOfBuisness,
        "ComplaintDetails": currentState.newComplaint.subject == "" || currentState.newComplaint.subject == null ? null : currentState.newComplaint.subject,
        "OpeningDate": currentState.newComplaint.openingDate == "" || currentState.newComplaint.openingDate == null ? null : currentState.newComplaint.openingDate,
        "MembershipNumber": currentState.newComplaint.membershipNumber == "" || currentState.newComplaint.membershipNumber == null ? null : currentState.newComplaint.membershipNumber,
        "Make": currentState.newComplaint.make == "" || currentState.newComplaint.make == null ? 0 : currentState.newComplaint.make,
        "ClaimNumber": currentState.newComplaint.claimNumber == "" || currentState.newComplaint.claimNumber == null ? null : currentState.newComplaint.claimNumber,
        "ComplaintDesc": currentState.newComplaint.comment == "" || currentState.newComplaint.comment == null ? null : currentState.newComplaint.comment,
        "EmiratesId": currentState.newComplaint.emiratesId == "" || currentState.newComplaint.emiratesId == null ? null : currentState.newComplaint.emiratesId,
        "ModuleName": "ComplaintsFeedBack",
        "Documents": [{ "Documents": documents }]
      }
      let sr = await complaintsservice.saveComplaintInfo(saveComplaintInfo);
      if (sr.hasErrors) {
        dispatch(appActions.showMessageForValidationErrorsCompliants(sr));
        //dispatch(appActions.showValidationErrors(sr));
        return Promise.reject();
      }
      console.log("complaint paged result", sr);

      /*if (sr.result.complaintId) {
          // dispatch(updateNewComplaintParams({ name:"complaintId", value:sr?.result?.complaintId }));
          await dispatch(getComplaintInfo(sr?.result?.complaintId));
          await dispatch(getComplaintDetails(sr?.result?.complaintId));
      }*/
      if (sr.result != null) {
        console.log("complaintInfo", sr.result.complaintInfo);
        console.log("complaintDetails", sr.result.complaintDetails);
        dispatch(getComplaintInfoEnd(sr.result.complaintInfo));
        dispatch(getComplaintDetailsEnd(sr.result.complaintDetails));
        let dialogeData = {
          message: `Successfully Saved Complaint Number ${sr.result.complaintInfo.complaintNumber}!`,
          showConfirmPopup: true,
          isConfirm: false,
          isInfo: true,

        }
        dispatch(toggleConfirmPopup(dialogeData));
      }
      return true;

    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export function saveWhistleBlowing() {
  return async function (dispatch, state) {
    let currentState = getState(state());
    console.log('587866', currentState.documents.documentList);
    let documents = currentState.documents.documentList;
    try {
      dispatch(appActions.setLoading(true));
      let saveComplaintInfo = {
        "SourceName": 11,
        "FullName": currentState.whistleBlowing.fullName == "" || currentState.whistleBlowing.fullName == null ? null : currentState.whistleBlowing.fullName,
        "Email": currentState.whistleBlowing.email == "" || currentState.whistleBlowing.email == null ? null : currentState.whistleBlowing.email,
        "MobileNumber": currentState.whistleBlowing.mobileNumber == "" || currentState.whistleBlowing.mobileNumber == null ? null : currentState.whistleBlowing.mobileNumber,
        //"PostalAddress": currentState.whistleBlowing.postalAddress == "" || currentState.whistleBlowing.postalAddress == null ? null : currentState.whistleBlowing.postalAddress,
        "ComplaintDesc": currentState.whistleBlowing.comment == "" || currentState.whistleBlowing.comment == null ? null : currentState.whistleBlowing.comment,
        "ModuleName": "WhistleBlowing",
        "Documents": [{ "Documents": documents }]
      }
      let sr = await complaintsservice.saveComplaintInfoWhistleBlowing(saveComplaintInfo);
      if (sr.hasErrors) {
        dispatch(appActions.showMessageForValidationErrorsCompliants(sr));
        //dispatch(appActions.showValidationErrors(sr));
        return Promise.reject();
      }
      console.log("complaint paged result", sr);

      /*if (sr.result.complaintId) {
          // dispatch(updatewhistleBlowingParams({ name:"complaintId", value:sr?.result?.complaintId }));
          await dispatch(getComplaintInfo(sr?.result?.complaintId));
          await dispatch(getComplaintDetails(sr?.result?.complaintId));
      }*/
      if (sr.result != null)
         {
       // console.log("complaintInfo", sr.result.complaintInfo);
      //  console.log("complaintDetails", sr.result.complaintDetails);
       // dispatch(getComplaintInfoEnd(sr.result.complaintInfo));
       // dispatch(getComplaintDetailsEnd(sr.result.complaintDetails));
        let dialogeData = {
          message: `Your request has been submitted successfully.
        Thank you for raising your concern. Your submission will be treated confidentially and reviewed by the appropriate authorized personnel in accordance with our whistleblowing procedures.
        We appreciate your contribution to maintaining a transparent and responsible organization.`,
          showConfirmPopup: true,
          isConfirm: false,
          isInfo: true,

        }
        dispatch(toggleConfirmPopup(dialogeData));
        dispatch(resetWhistleBlowingParamsWithoutComplaint());
      }
      return true;

    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const updateComplaintTypeState = (status, value) => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      let lobId = value == null ? currentState.complaintDetails.lineOfBuisness : value;
      let sublobId = value == null ? currentState.complaintDetails.subLineOfBuisness : value;
      dispatch(appActions.setLoading(true));
      let sr = null;
      if (lobId != null && lobId != "") {
        sr = await complaintsservice.getComplaintTypeMasterBySubLobType(lobId, sublobId);
      }
      else { return false; }
      if (sr.hasErrors) {
        return false;
      }
      dispatch(getComplaintTypeMasterBySubLobTypeEnd("complaintType", sr, status));
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const getComplaintTypeMasterBySubLobTypeEnd = (section, complaintAboutMasters, status) => {
  return {
    type: types.GET_COMPLAINT_TYPE_MASTERS_END,
    payload: { section, complaintAboutMasters, status }
  }
}
export const changeValidationMessage = ({ name, value }) => {
  return {
    type: types.CHANGE_VALIDATION_ERROR_MESSAGE,
    payload: { name, value }
  }
}
export const resetValidationMessage = () => {
  return {
    type: types.RESET_VALIDATION_ERROR_MESSAGE,

  }
}
export const showSuccessDialoge = (data) => {
  return {
    type: types.CREATE_NEW_DIALOG_SUCCESS,
    payload: data
  }
}

export function getComplaintInfo(complaintId) {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      let para = {
        'complaintId': complaintId
      }
      dispatch(appActions.setLoading(true));
      let result = await complaintsservice.getComplaintInfo(para);
      console.log('LIST', result)

      //console.log(sr)
      //   if (result==null)
      //     return false;
      //  if(result.complaintId) 
      if (result != null) {

        dispatch(getComplaintInfoEnd(result));
        let dialogeData = {
          message: `Successfully Saved Complaint Number ${result.complaintInfo.complaintNumber}!`,
          showConfirmPopup: true,
          isConfirm: false,
          isInfo: true,

        }
        dispatch(toggleConfirmPopup(dialogeData));
        //dispatch(updateComplaintTypeState(true,result));
      }


      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const resetComplaintSearchResult = () => {
  return {
    type: types.RESET_COMPLAINT_SEARCH_RESULT
  }
}
export const getComplaintInfoEnd = (result) => {
  console.log("1212131", result);
  return {
    type: types.GET_COMPLAINT_INFO_END,
    payload: result
  }
}
export const toggleConfirmPopup = (data) => {
  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        type: types.TOGGLE_CONFRIM_POPUP,
        payload: {
          ...data,
          resolve: resolve,  // resolve the promise when the user clicks Yes/No
        }
      });
    });
  };
};
export const confirmYes = () => ({
  type: types.CONFIRM_YES,
});

export const confirmNo = () => ({
  type: types.CONFIRM_NO,
});

export const updateWhistleBlowingParams = ({ name, value }) => {
  return {
    type: types.UPDATE_WHISTLE_BLOWING_PARAMS,
    payload: { name, value }
  }
}
export const resetWhistleBlowingParamsWithoutComplaint = () => {
  return {
    type: types.RESET_NEW_WHISTLE_BLOWING_WITHOUT_COMPLAINT_NUMBER
  }
}
const getState = (state) => {
  return state.complaintandfeedbackReducer;
};